module.exports = __webpack_public_path__ + "static/media/imageplacholder.5d5b0704.svg";